import { PortalLogger as log } from "@/utils";
import "intro.js/minified/introjs.min.css";
import "./portal-intro.css";
const introJS = require("intro.js");

const TUTORIAIS = {
    "TAREFAS_AVISOS": [{
        title: 'Avisos e Tarefas',
        intro: 'Olá! A listagem de tarefas do Portal mudou, venha ver como ficou!'
    },{
        element: '.portal-tarefas-cartao',
        title: 'Tarefas',
        intro: 'As suas tarefas atuais estarão nesse cartão.'
    },{
        element: '.portal-tarefas-cartao .btn-pendente-adiado',
        title: 'Adiar Tarefa',
        intro: 'Agora é possível adiar uma tarefa para outro dia, clicando em <i class="fas fa-stopwatch"></i>. Clique aqui para mostrar a lista de tarefas adiadas.',
        position: 'bottom'
    },{
        title: 'Avisos',
        element: '.portal-avisos-cartao',
        intro: 'Aqui ficam os avisos das diferentes áreas de negócio (similar aos Avisos Web). Clique em um deles para ver mais detalhes.'
    },{
        title: 'Notificações',
        element: '#header-alerts-dropdown',
        intro: 'E por último, aqui ficam as suas notifições de tarefas e avisos mais recentes.',
        fixed: true,
        position: 'bottom'
    }]
};


class PortalIntro {
    
    constructor(){
        this.passos = null;
        this.identificador = null;
    }

    carregar(identificador){
        this.identificador = identificador;
        this.passos = TUTORIAIS[identificador];
        if(!this.passos){
            log.error(`Não foi encontrado o tutorial para o identificador ${identificador}`);
        }
        return this;
    }

    iniciar(){
        const self = this;
        if(self.isExecutado()) return;

        self.passos.forEach(p => {
            if(p.element) p.element = document.querySelector(p.element);
        });
        introJS().setOptions({
            steps: self.passos,
            showProgress: true,
            nextLabel: ' >> ',
            prevLabel: ' << ',
            skipLabel: 'X',
            doneLabel: 'Pronto!',
            
        }).onexit(function() {
            self.setExecutado();
            self.limpar();
        }).onbeforechange(function() {
            let passo = self.passos[this._currentStep];
            if(passo.fixed){
                let container = document.querySelector('html');
                container.scrollTop = 0;
            }
        }).start();
    }

    isExecutado(){
        return localStorage.getItem(this.identificador) == 1;
    }

    limpar() {
        this.identificador = null;
        this.passos = null;
    }

    setExecutado(){
        localStorage.setItem(this.identificador, 1);
    }

}

export default new PortalIntro();